import { useRequest } from "@onefront/react-sdk";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { CodeBox } from "../CodeBox";

export const FullUrlRequest = ({ exampleUrl }) => {
  const { loading, data, error, fetch } = useRequest({
    method: "get",
    lazy: true,
    url: exampleUrl
  });

  return (
    <Box sx={{ mb: "20px" }}>
      <ExtendedTypography variant="titleSmall">
        useRequest for an external API
      </ExtendedTypography>
      <CodeBox>
        {`
const { loading, data, error, fetch } = useRequest({
  lazy:   true,
  method: "get",
  url:    "http://chuck-norris.com"
});
        `.trim()}
      </CodeBox>
      <Box
        sx={{ display: "flex", flexDirection: "row", alignItems: "baseline" }}
      >
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={fetch}
          disabled={loading}
        >
          Click me
        </Button>
        {loading && "Loading random Chuck Norris joke..."}
        {error && `ERROR: ${error.message}`}
      </Box>
      {data && <CodeBox>{data.value}</CodeBox>}
    </Box>
  );
};
